// Les rôles de l'utilisateur connecté (claim `role` du jeton : une chaîne, ou une liste).

const roles = (user) => {
  const brut = user?.role;
  const liste = Array.isArray(brut) ? brut : [brut];
  return liste.filter(Boolean).map((r) => String(r).toLowerCase());
};

/** Administrateur ou super-administrateur. */
export const estAdmin = (user) => roles(user).some((r) => r === 'admin' || r === 'superadmin');

/** Gestion des signatures : chez Salat Janaza il n'y a pas de rôle super-admin
 *  (l'IdentityServer n'émet que « admin »), elle est donc ouverte à tous les admins. */
export const peutGererSignatures = estAdmin;
